import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { WidgetSearch } from '@app/cp/shared/models/WidgetSearch';

@Component({
    selector: 'cp-body',
    templateUrl: './body.component.html',
    styleUrls: ['./body.component.scss'],
})
export class BodyComponent implements OnInit {

    constructor() { }

    @Input() widgetObject: any;
    @Input() widgetIndex: number = -1;

    @Output() loaderState = new EventEmitter<any>();
    @Output() loaderErrorState = new EventEmitter<any>();
    @Output() searchParams = new EventEmitter<WidgetSearch>();

    ngOnInit() {
    }

    ngAfterViewInit() {
        
    }

    showFilter: boolean = false;

    showFilterPopup() {
        this.showFilter = !this.showFilter;
    }

    changeLoader(e) {
        this.loaderState.emit(e);
    }

    changeErrorLoader(e) {
        this.loaderErrorState.emit(e);
    }

    setSearchParams(searchParams: WidgetSearch) {
        this.searchParams.emit(searchParams);
    }

    public data: any[] = [{
        kind: 'Hydroelectric', share: 0.175
    }, {
        kind: 'Nuclear', share: 0.238
    }, {
        kind: 'Coal', share: 0.118
    }, {
        kind: 'Solar', share: 0.052
    }, {
        kind: 'Wind', share: 0.225
    }, {
        kind: 'Other', share: 0.192
    }];
}